// ** Router imports
import {lazy} from 'react'

// ** Router imports
import {Navigate, useRoutes} from 'react-router-dom'

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'
import BlankConfirmLayout from '@layouts/BlankConfirmLayout'

// ** Hooks Imports
import {useLayout} from '@hooks/useLayout'

// ** Utils
import {getHomeRoute} from '../utility/RouterUtils'

// ** GetRoutes
import {getRoutes} from './routes'

// ** Components
const Error = lazy(() => import('../pages/misc/NotFound'))
const Login = lazy(() => import('../pages/authentication/Login'))
const Register = lazy(() => import('../pages/authentication/Register'))
const ForgotPassword = lazy(() => import('../pages/authentication/ForgotPassword'))
const ActivateAccount = lazy(() => import('../pages/authentication/ActivateAccount'))
const RequestActivateAccount = lazy(() => import('../pages/authentication/RequestActivateAccount'))
const ResetPassword = lazy(() => import('../pages/authentication/ResetPassword'))
const NotAuthorized = lazy(() => import('../pages/misc/NotAuthorized'))
const ReservationPaymentWithoutLogin = lazy(() => import('../pages/reservation/new-reservation/ReservationPaymentWithoutLogin'))
const ReservationPaymentConfirm = lazy(() => import('../pages/reservation/new-reservation/ReservationPaymentConfirm'))
const NewReservation = lazy(() => import('../pages/reservation/new-reservation/NewReservation'))

const Router = () => {
    // ** Hooks
    const {layout} = useLayout()

    const allRoutes = getRoutes(layout)

    const routes = useRoutes([
        {
            path: '/',
            index: true,
            element: <Navigate replace to={getHomeRoute()}/>
        },
        {
            path: '/login',
            element: <BlankLayout/>,
            children: [{path: '/login', element: <Login/>}]
        },
        {
            path: '/register',
            element: <BlankLayout/>,
            children: [{path: '/register', element: <Register/>}]
        },
        {
            path: '/forgot-password',
            element: <BlankLayout/>,
            children: [{path: '/forgot-password', element: <ForgotPassword/>}]
        },
        {
            path: '/activate-account',
            element: <BlankLayout/>,
            children: [{path: '/activate-account', element: <ActivateAccount/>}]
        },
        {
            path: '/request-activate-account',
            element: <BlankLayout/>,
            children: [{path: '/request-activate-account', element: <RequestActivateAccount/>}]
        },
        {
            path: '/reset-password',
            element: <BlankLayout/>,
            children: [{path: '/reset-password', element: <ResetPassword/>}]
        },
        {
            path: '/auth/not-auth',
            element: <BlankLayout/>,
            children: [{path: '/auth/not-auth', element: <NotAuthorized/>}]
        },
        {
            path: '/new-reservation',
            element: <BlankConfirmLayout/>,
            children: [
                {
                    path: '/new-reservation',
                    element: <NewReservation isPublic={true}/>
                }
            ]
        },
        {
            path: '/reservation/:parking/:reservation',
            element: <BlankConfirmLayout/>,
            children: [
                {
                    path: '/reservation/:parking/:reservation',
                    element: <ReservationPaymentWithoutLogin/>
                }
            ]
        },
        {
            path: '/reservation_status',
            element: <BlankConfirmLayout/>,
            children: [
                {
                    path: '/reservation_status',
                    element: <ReservationPaymentConfirm/>
                }
            ]
        },
        {
            path: '*',
            element: <BlankLayout/>,
            children: [{path: '*', element: <Error/>}]
        },
        ...allRoutes
    ])

    return routes
}

export default Router
